
import { useAuth0 } from "@auth0/auth0-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Skeleton } from "@/components/ui/skeleton";
import { useAuthBypass } from "@/lib/auth";

const isAuthDisabled = import.meta.env.VITE_DISABLE_AUTH === "true";

export const UserProfile = () => {
  const auth = isAuthDisabled ? useAuthBypass() : useAuth0();
  const { user, isAuthenticated, isLoading } = auth;

  if (isLoading) {
    return <Skeleton className="h-10 w-10 rounded-full" />;
  }

  if (!isAuthenticated || !user) {
    return null;
  }

  return (
    <div className="flex items-center gap-2">
      <Avatar>
        <AvatarImage src={user.picture} alt={user.name} />
        <AvatarFallback>{user.name?.charAt(0)}</AvatarFallback>
      </Avatar>
      <div className="text-sm">
        <p className="font-medium">{user.name}</p>
        <p className="text-xs text-muted-foreground">{user.email}</p>
      </div>
    </div>
  );
};
